<template>
    <img :src="src" :alt="country.name" :srcset="srcSet" :width="width" v-bind="$attrs" />
</template>

<script>
import Country from '@/Models/Country.js';

export default {
    name: 'CountryFlag',

    props: {
        country: {
            type: Country,
            required: true,
        },

        width: {
            type: String,
            required: false,
            default: '80',
        },
    },

    computed: {
        src() {
            return `https://flagcdn.com/w${this.width}/${this.country.alpha2.toLowerCase()}.png`;
        },

        srcSet() {
            return `https://flagcdn.com/w320/${this.country.alpha2.toLowerCase()}.png 2x`;
        },
    },
};
</script>

<style scoped lang="scss"></style>
